<template>
  <v-container class="pa-0" fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import AdminParameters from '@/views/administration/parameters/AdminParameters'
import AdminRecords from '@/views/administration/records/AdminRecords'
import AdminData from '@/views/administration/data/AdminData'
import JarContainer from '@/views/administration/jarFailedJobs/JarContainer'
import SystemNotifications from '@/views/administration/systemNotifications/SystemNotifications'
import AdminSystemNotificationForm from '@/views/administration/systemNotifications/AdminSystemNotificationForm'
import SystemBlacklist from '@/views/administration/blacklist/Blacklist'
import PerformedSearches from '@/views/administration/performedSearches/PerformedSearches'
import logsIndex from '@/views/administration/logs/logsIndex'
import ViewDataIndex from '@/views/administration/viewData/ViewDataIndex'
import PersonRulesIndex from './personRules/PersonRulesIndex.vue'
import ObjectPersonRuleForm from './personRules/objectPersonRules/ObjectPersonRuleForm.vue'
import SigningPersonRuleForm from './personRules/signingPersonRules/SigningPersonRuleForm.vue'
import PublicJaLFormsIndex from './publicJaList/PublicJaLFormsIndex.vue'
import JarFactIpasRolesIndex from './jarFactIpasRoles/JarFactIpasRolesIndex.vue'

export default {
  name: 'AdminTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Draudžiami paslaugų teikėjai',
          route: 'adminSystemBlacklist',
          component: SystemBlacklist,
        },
        {
          title: 'Sistemos pranešimai',
          route: 'adminSystemNotifications',
          component: SystemNotifications,
        },
        {
          title: 'Sistemos pranešimas',
          route: 'adminSystemNotificationForm',
          component: AdminSystemNotificationForm,
        },
        {
          title: 'Sistemos parametrai',
          route: 'adminParameters',
          component: AdminParameters,
        },
        {
          title: 'Sisteminiai įrašai',
          route: 'adminRecords',
          component: AdminRecords,
        },
        {
          title: 'Doumenų valdymas',
          route: 'adminData',
          component: AdminData,
        },
        {
          title: 'JAR duomenų valdymas',
          route: 'JarContainer',
          component: JarContainer,
        },
        {
          title: 'Nepavykę JAR duomenų perdavimai',
          route: 'adminJarFailedJobs',
          component: JarContainer,
        },
        {
          title: 'Juridiniai asmenys be OBJ_ID',
          route: 'adminLegalentitiesWithoutObj',
          component: JarContainer,
        },
        {
          title: 'Įgaliojimų / prokūrų atliktos paieškos',
          route: 'performedSearches',
          component: PerformedSearches,
        },
        {
          title: 'Užklausų žurnalas',
          route: 'adminLogs',
          component: logsIndex,
        },
         {
          route: 'adminLogNirvar',
          component: logsIndex,
        },
           {
          route: 'adminLogSaperion',
          component: logsIndex,
        },
         {
          route: 'adminLogJarProcuracy',
          component: logsIndex,
        },
         {
          route: 'adminLogAsmenys',
          component: logsIndex,
        },
         {
          route: 'adminLogPas',
          component: logsIndex,
        },
         {
          route: 'adminLogBroker',
          component: logsIndex,
        },
         {
          route: 'adminLogApiRequest',
          component: logsIndex,
        },


        {
          title: 'View duomenys',
          route: 'viewData',
          component: ViewDataIndex,
        },
        {
          route: 'viewDataFft',
          component: ViewDataIndex,
        },
        {
          route: 'viewDataFate',
          component: ViewDataIndex,
        },

        {
          title: 'Viešų JA sąrašas',
          route: 'publicJaForms',
          component: PublicJaLFormsIndex
        },
        {
          title: 'Asmenų pridėjimo taisyklės',
          route: 'personRules',
          component: PersonRulesIndex
        },

        {
          title: 'Objektų asmenys',
          route: 'objectPersonRules',
          component: PersonRulesIndex
        },
        {
          title: 'Objektų asmenys pridėjimo taisyklės',
          route: 'objectPersonRuleForm',
          component: ObjectPersonRuleForm,
        },
        {
          title: 'Pasirašantys asmenys',
          route: 'signingPersonRules',
          component: PersonRulesIndex
        },
        {
          title: 'Pasirašančių asmenų ištraukimo taisyklės',
          route: 'signingPersonRuleForm',
          component: SigningPersonRuleForm,
        },
        {
          title: 'JAR faktas ir iPasas vaidmuo',
          route: 'jarFactIpasRoles',
          component: JarFactIpasRolesIndex
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
